<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Warehouse"
                    v-model="form.warehouse_id"
                    item-text="name"
                    item-value="id"
                    :items="warehouses"
                    @update:search-input="searchWarehouses"
                    outlined
                    :rules="[isRequired]"
                    dense
                    hide-details="auto"
                    >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Item"
                    v-model="form.item_id"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="display_name"
                    item-value="id"
                    :items="items"
                    :rules="[isRequired]"
                    @update:search-input="searchItems"
                    >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Min Quantity"
                    v-model="form.min"
                    :suffix="itemMeasureUnit ? itemMeasureUnit.abbreviation : null"
                    :rules="[isNumeric]"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
            <v-col>
                <v-text-field
                    label="Max Quantity"
                    v-model="form.max"
                    :suffix="itemMeasureUnit ? itemMeasureUnit.abbreviation : null"
                    :rules="[isNumeric]"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Location"
                    v-model="form.location"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isNumeric, isRequired } from './../../utils/validations';

export default {
    name: "WarehouseItemForm",
    props: {    
        value: Object,
    },
    data() {
        return {
            form: {
                warehouse_id: null,
                item_id: null,
                min: null,
                max: null,
                location: null
            }
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    computed:{
        ...mapGetters({
            warehouses: "warehouse/warehouse/search/data",
            items: "stock/item/search/data"
        }),
        item() {
            return this.items.find(item => item.id == this.form.item_id);
        },
        itemMeasureUnit() {
            if(!this.item) return null;
            return this.item.measure_unit;
        }
    },
    methods: {
        isNumeric, isRequired,
        ...mapActions({
            searchWarehouses: "warehouse/warehouse/search/get",
            searchItems: "stock/item/search/get"
        }),
        validate() {
            return this.$refs.form.validate();
        }
    },
    mounted() {
        if(this.value) {
            this.form = {...this.value}
        }
    }
}
</script>

<style>

</style>